import {GameStateEnums} from '../../../../../shared/GameEnums'
import {ActionsThatCanBeCancelled, BeginnerHintFormat, GameAction} from '@colonist/game-base-types'
import {PIXI} from '@colonist/pixi'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGameActionButtonView} from './UIGameActionButtonView'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {UIGameActionButtonPositions} from './UIGameActionsController'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIGameBeginnerHintView} from '../ui_game_beginner_hints/UIGameBeginnerHintView'
import {Sound} from '../../Sound'
import {BeginnerModeActionState} from '@colonist/game-state-types'
import {HiddenUIElement} from '@colonist/game-beginner-mode'
import {FloatingText} from '../../game_ui_view_objects/FloatingText'
import {MechanicValidatorDevelopmentCard} from '@colonist/game-mechanic-validators'
import {CardEnum, MechanicDevelopmentCardsState, TurnState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export class UIGameActionButtonBuyDevelopmentCard extends UIGameActionButtonView implements UIGameMechanic {
    private readonly validatorBuyDevelopmentCard: MechanicValidatorDevelopmentCard

    constructor(uiGameManager: UIGameManager, devCardsState: MechanicDevelopmentCardsState, container: PIXI.Container) {
        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.card_devcardback)
        super(uiGameManager, UIGameActionButtonPositions.DevCard, container)
        this.addCenteredIcon(texture)
        this.repositionedButton = () => {
            const beginnerHintActive = this.beginnerHintView != undefined
            this.destroyBeginnerHintView()
            if(beginnerHintActive) this.beginnerHintReceived({type: GameAction.BuyDevelopmentCard, data: {}})
        }

        this.validatorBuyDevelopmentCard = new MechanicValidatorDevelopmentCard(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, devCardsState)

        this.setUpdateAction()
        this.gameStateUpdated()
        const cardsToBuyDevelopmentCard = [CardEnum.Wool, CardEnum.Grain, CardEnum.Ore]
        this.setHoverAction(cardsToBuyDevelopmentCard)
    }

    buttonSpecificEvents(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated:
            case UIGameEventEnums.GameStateUpdated: this.gameStateUpdated(); break
            case UIGameEventEnums.BeginnerHintReceived: this.beginnerHintReceived(data); break
            case UIGameEventEnums.BeginnerModeActionUpdated: this.onBeginnerModeActionUpdate(data); break
            case UIGameEventEnums.BeginnerModeInteractWithGuide: this.onBeginnerModeInteractWithGuide(data, GameAction.BuyDevelopmentCard); break
            default: break
        }
    }

    private setUpdateAction() {
        this.updateAction(() => {
            this.clickedBuyDevelopmentCard()
        })
    }

    private clickedBuyDevelopmentCard() {
        const canBuyDevCard = this.validatorBuyDevelopmentCard.canPlayerBuyDevelopmentCard(this.myPlayer.color)
        if(!this.canPerformBuyAction(canBuyDevCard)) return
        this.uiGameManager.socketGameSend.buyDevCard()
    }

    private gameStateUpdated() {
        this.inactivateOpacity()
        this.removeHighlight()
        this.destroyBeginnerHintView()

        if(!this.uiGameManager.gameController.isMyTurn) return
        if(!this.validatorBuyDevelopmentCard.canPlayerBuyDevelopmentCard(this.myPlayer.color).canTakeAction) return
        if(this.isBeginnerMode && this.beginnerModeActionType != GameAction.BuyDevelopmentCard) return

        this.updateOpacityForTurnState()
    }

    private updateOpacityForTurnState() {
        if(!this.allowableTurnStates()) return
        if(!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, this.uiGameManager.gameController.currentState.actionState)) return
        this.activateOpacity()
    }

    private allowableTurnStates(): boolean {
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.Turn) return true
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.SpecialBuildPhase) return true

        return false
    }

    private beginnerHintReceived(data: BeginnerHintFormat) {
        if(this.parent == undefined) return
        if(data.type != GameAction.BuyDevelopmentCard) return

        this.destroyBeginnerHintView()
        Sound.playSound(Sound.SoundType.BeginnerHintActivated)
        this.beginnerHintView = new UIGameBeginnerHintView(this.uiGameManager, this, {key: 'strings:game.beginnerTips.actionHints.description', options: {context: 'buyDevCard'}}, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.card_devcardback))
    }

    private onBeginnerModeActionUpdate(data: BeginnerModeActionState) {
        this.setShouldRevealButton(data, HiddenUIElement.BuyDevCardActionButton, GameAction.BuyDevelopmentCard)
        this.gameStateUpdated()

        const canBuyDevCard = data.type == GameAction.BuyDevelopmentCard
        canBuyDevCard ? this.setUpdateAction() : this.updateAction(() => new FloatingText({key: 'strings:game.errors.finishCurrentAction'}, this))

        const isVisible: boolean = !data.hiddenUIElements.includes(HiddenUIElement.BuyDevCardActionButton)
        this.visible = isVisible
    }
}
